import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { articles } from '@/mocks/articleData';

const articleImages: Record<string, string> = {
  'article-best-products': 'https://readdy.ai/api/search-image?query=Top%20down%20flat%20lay%20of%20curated%20fashion%20products%20including%20sneakers%20watch%20and%20accessories%20arranged%20on%20white%20marble%20surface%20with%20soft%20morning%20light%20from%20window%20creating%20delicate%20shadows%20clean%20editorial%20composition%20with%20plenty%20of%20breathing%20space%20modern%20luxury%20aesthetic%20high%20detail%20product%20photography&width=1200&height=675&seq=art-best-prods-v2&orientation=landscape',
  'article-vs-pandabuy': 'https://readdy.ai/api/search-image?query=Split%20composition%20showing%20two%20contrasting%20shopping%20experiences%20left%20side%20organized%20spreadsheet%20interface%20on%20laptop%20right%20side%20cluttered%20browser%20tabs%20on%20screen%20warm%20wood%20desk%20setting%20with%20natural%20light%20modern%20comparison%20concept%20editorial%20tech%20photography%20clean%20aesthetic&width=1200&height=675&seq=art-vs-panda-v2&orientation=landscape',
  'article-is-safe': 'https://readdy.ai/api/search-image?query=Close%20up%20of%20hands%20carefully%20inspecting%20a%20product%20package%20with%20magnifying%20glass%20on%20clean%20white%20desk%20soft%20natural%20light%20from%20window%20minimal%20composition%20conveying%20trust%20and%20quality%20control%20modern%20European%20editorial%20style%20with%20warm%20neutral%20tones%20and%20sharp%20focus%20on%20the%20inspection%20moment&width=1200&height=675&seq=art-is-safe-v2&orientation=landscape',
  'article-how-to-use': 'https://readdy.ai/api/search-image?query=Overhead%20shot%20of%20hands%20typing%20on%20laptop%20next%20to%20notebook%20with%20handwritten%20steps%20and%20a%20cup%20of%20coffee%20on%20light%20oak%20wooden%20desk%20natural%20morning%20light%20streaming%20through%20blinds%20creating%20soft%20stripe%20shadows%20clean%20organized%20workspace%20editorial%20photography%20warm%20inviting%20atmosphere&width=1200&height=675&seq=art-howto-v2&orientation=landscape',
  'article-best-shoes': 'https://readdy.ai/api/search-image?query=Three%20pairs%20of%20stylish%20sneakers%20in%20different%20colors%20arranged%20on%20concrete%20floor%20with%20natural%20sunlight%20from%20large%20window%20creating%20dramatic%20shadows%20urban%20loft%20aesthetic%20clean%20modern%20product%20photography%20with%20industrial%20backdrop%20minimal%20composition%20high%20detail%20editorial%20style&width=1200&height=675&seq=art-best-shoes-v2&orientation=landscape',
  'article-best-clothing': 'https://readdy.ai/api/search-image?query=Carefully%20folded%20stack%20of%20premium%20clothing%20including%20hoodie%20tshirt%20and%20jacket%20on%20light%20wooden%20surface%20with%20soft%20afternoon%20light%20from%20side%20window%20creating%20gentle%20shadows%20minimalist%20fashion%20editorial%20aesthetic%20warm%20earthy%20tones%20clean%20uncluttered%20composition&width=1200&height=675&seq=art-best-cloth-v2&orientation=landscape',
  'article-shipping': 'https://readdy.ai/api/search-image?query=Cardboard%20shipping%20box%20being%20opened%20on%20clean%20white%20table%20with%20packing%20materials%20visible%20soft%20natural%20window%20light%20modern%20ecommerce%20unboxing%20scene%20minimalist%20composition%20conveying%20excitement%20and%20care%20European%20editorial%20photography%20with%20warm%20neutral%20tones&width=1200&height=675&seq=art-shipping-v2&orientation=landscape',
  'article-seller-tips': 'https://readdy.ai/api/search-image?query=Professional%20looking%20at%20laptop%20screen%20displaying%20seller%20rating%20dashboard%20with%20star%20ratings%20and%20review%20data%20clean%20modern%20office%20setting%20with%20natural%20light%20from%20window%20focused%20atmosphere%20conveying%20trust%20and%20verification%20process%20editorial%20tech%20photography%20warm%20tones&width=1200&height=675&seq=art-seller-v2&orientation=landscape',
  'article-budget-buys': 'https://readdy.ai/api/search-image?query=Assorted%20affordable%20fashion%20items%20including%20sneakers%20cap%20and%20accessories%20arranged%20on%20light%20gray%20concrete%20background%20with%20soft%20diffused%20natural%20light%20clean%20composition%20highlighting%20value%20and%20style%20modern%20aesthetic%20editorial%20product%20photography%20with%20breathing%20space&width=1200&height=675&seq=art-budget-v2&orientation=landscape',
};

export default function ArticlePage() {
  const { slug } = useParams<{ slug: string }>();
  const article = articles.find((a) => a.slug === slug);
  const origin = typeof window !== 'undefined' ? window.location.origin : 'https://vigorbuy.help';

  if (!article) {
    return (
      <div className="min-h-screen bg-background-50">
        <title>Article Not Found | VigorBuy</title>
        <meta name="robots" content="noindex, follow" />
        <Navbar />
        <main className="pt-28 pb-16 text-center">
          <p className="text-foreground-600">Article not found.</p>
          <Link to="/" className="mt-4 inline-block text-primary-600 hover:text-primary-700 font-medium">Back to Homepage</Link>
        </main>
        <Footer />
      </div>
    );
  }

  const imageUrl = articleImages[article.imageSeq];
  const pageUrl = `${origin}/article/${article.slug}`;

  return (
    <div className="min-h-screen bg-background-50">
      <title>{article.metaTitle}</title>
      <meta name="description" content={article.description} />
      <meta name="robots" content="index, follow" />
      <link rel="canonical" href={pageUrl} />

      <Navbar />

      <main>
        {/* Article Hero */}
        <section className="bg-background-950 pt-28 pb-16 md:pt-32 md:pb-20">
          <div className="px-6 md:px-10">
            <div className="max-w-4xl mx-auto">
              {/* Breadcrumb */}
              <nav className="flex items-center gap-2 text-sm text-foreground-400 mb-6" aria-label="Breadcrumb">
                <Link to="/" className="hover:text-background-50 transition-colors whitespace-nowrap">Home</Link>
                <i className="ri-arrow-right-s-line text-xs"></i>
                <span className="text-background-50/70">{article.title}</span>
              </nav>

              <span className="inline-block px-3 py-1 text-xs font-medium text-accent-400 border border-accent-500/30 rounded-full whitespace-nowrap mb-4">
                {article.category}
              </span>
              <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-background-50 leading-tight">
                {article.title}
              </h1>
              <p className="mt-4 text-base md:text-lg text-foreground-300 leading-relaxed max-w-2xl">
                {article.description}
              </p>
              <div className="flex flex-wrap items-center gap-4 mt-6 text-xs text-foreground-400">
                <span><i className="ri-calendar-line mr-1"></i> Updated: June 2026</span>
                <span><i className="ri-time-line mr-1"></i> {article.readTime}</span>
                <span><i className="ri-user-line mr-1"></i> By VigorBuy Editorial Team</span>
              </div>
            </div>
          </div>
        </section>

        {/* Article Body */}
        <article className="py-12 md:py-16">
          <div className="px-6 md:px-10">
            <div className="max-w-3xl mx-auto">
              {/* Featured Image */}
              {imageUrl && (
                <div className="rounded-2xl overflow-hidden mb-10 aspect-[16/9] w-full">
                  <img
                    src={imageUrl}
                    alt={article.title}
                    title={article.title}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              )}

              {/* Dynamic Sections */}
              {article.sections.map((section, si) => {
                switch (section.type) {
                  case 'text':
                    return (
                      <div key={si}>
                        {section.paragraphs?.map((p, pi) => (
                          <p key={pi} className={`text-base text-foreground-700 leading-relaxed ${pi > 0 ? 'mt-4' : ''}`}>
                            {p}
                          </p>
                        ))}
                      </div>
                    );

                  case 'heading':
                    return (
                      <h2 key={si} className="mt-12 text-2xl md:text-3xl font-heading font-bold text-foreground-950">
                        {section.heading}
                      </h2>
                    );

                  case 'list':
                    return (
                      <div key={si} className="mt-6 space-y-4">
                        {section.items?.map((item, ii) => (
                          <div key={ii} className="bg-background-100 rounded-xl p-5">
                            {item.title && <h4 className="text-base font-semibold text-foreground-900">{item.title}</h4>}
                            {item.desc && <p className="mt-1 text-sm text-foreground-600 leading-relaxed">{item.desc}</p>}
                          </div>
                        ))}
                      </div>
                    );

                  case 'tips':
                    return (
                      <div key={si} className="mt-6 bg-accent-50 border border-accent-200 rounded-xl p-6">
                        <ul className="space-y-3">
                          {section.items?.map((item, ii) => (
                            <li key={ii} className="flex items-start gap-3">
                              <span className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                                <i className="ri-lightbulb-line text-accent-600"></i>
                              </span>
                              <span className="text-sm text-foreground-700 leading-relaxed">{item.desc}</span>
                            </li>
                          ))}
                        </ul>
                      </div>
                    );

                  case 'cta':
                    return (
                      <div key={si} className="mt-10 flex flex-col sm:flex-row gap-4">
                        <a
                          href="https://kaspreadsheet.com"
                          target="_blank"
                          rel="noopener nofollow"
                          className="flex-1 px-6 py-3.5 text-base font-semibold bg-primary-500 text-background-50 rounded-lg hover:bg-primary-600 transition-colors text-center whitespace-nowrap"
                        >
                          Open VigorBuy Spreadsheet
                          <i className="ri-arrow-right-line ml-2"></i>
                        </a>
                        <Link
                          to="/"
                          className="flex-1 px-6 py-3.5 text-base font-semibold border-2 border-foreground-900 text-foreground-900 rounded-lg hover:bg-foreground-900 hover:text-background-50 transition-colors text-center whitespace-nowrap"
                        >
                          Back to Homepage
                          <i className="ri-home-4-line ml-2"></i>
                        </Link>
                      </div>
                    );

                  default:
                    return null;
                }
              })}

              {/* Internal link back to homepage */}
              <div className="mt-12 pt-8 border-t border-background-200">
                <Link
                  to="/"
                  className="inline-flex items-center gap-2 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
                >
                  <i className="ri-arrow-left-line"></i>
                  Back to VigorBuy Spreadsheet Homepage
                </Link>
              </div>

              {/* Article Schema */}
              <script
                type="application/ld+json"
                dangerouslySetInnerHTML={{
                  __html: JSON.stringify({
                    '@context': 'https://schema.org',
                    '@type': 'Article',
                    headline: article.title,
                    description: article.description,
                    author: { '@type': 'Organization', name: 'VigorBuy Editorial Team' },
                    datePublished: '2026-06-29',
                    dateModified: '2026-06-29',
                    publisher: { '@type': 'Organization', name: 'VigorBuy', url: origin },
                    mainEntityOfPage: { '@type': 'WebPage', '@id': pageUrl },
                  }),
                }}
              />

              {/* BreadcrumbList Schema */}
              <script
                type="application/ld+json"
                dangerouslySetInnerHTML={{
                  __html: JSON.stringify({
                    '@context': 'https://schema.org',
                    '@type': 'BreadcrumbList',
                    itemListElement: [
                      { '@type': 'ListItem', position: 1, name: 'Home', item: origin },
                      { '@type': 'ListItem', position: 2, name: article.title, item: pageUrl },
                    ],
                  }),
                }}
              />
            </div>
          </div>
        </article>
      </main>

      <Footer />
    </div>
  );
}